var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnavailable18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.243 13.172a5 5 0 0 0 6.929-6.929l-6.93 6.929zm-1.415-1.415l6.93-6.929a5 5 0 0 0-6.929 6.929zM9 16A7 7 0 1 1 9 2a7 7 0 0 1 0 14z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTYuMjQzIDEzLjE3MmE1IDUgMCAwIDAgNi45MjktNi45MjlsLTYuOTMgNi45Mjl6bS0xLjQxNS0xLjQxNWw2LjkzLTYuOTI5YTUgNSAwIDAgMC02LjkyOSA2LjkyOXpNOSAxNkE3IDcgMCAxIDEgOSAyYTcgNyAwIDAgMSAwIDE0eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export { SvgUnavailable18 as ReactComponent };